module.exports = __webpack_public_path__ + "static/media/fly0146.9e27fec0.webp";